import { useEffect, useRef, useState } from 'react';
import {useParams} from 'react-router-dom';
import GiglistBanner from '../../components/PageComponents/GigListPageComponents/GigListBanner/GiglistBanner';
import GigListContainer from '../../components/PageComponents/GigListPageComponents/GigListContainer/GigListContainer';
import GigListSorter from '../../components/PageComponents/GigListPageComponents/GigListSorter/GigListSorter';
import Navbar from '../../components/CommonComponents/Navbar/Navbar';
import PaginationComp from '../../components/UtilityComponents/Pagination/PaginationComp';
import { GigAPIHandler } from '../../services/NetworkClient/BackendAPIs/GigAPIHandler';
import { SubcategoryAPIHandler } from '../../services/NetworkClient/BackendAPIs/SubcategoryAPIhandler';
import { Subcategory } from '../../Models/SubCategory';
import Gig from '../../Models/Gig';
import SnackBar, { SnackTypes } from '../../components/UtilityComponents/SnackBar/SnackBar';
import GGLoaderView from '../../components/UtilityComponents/GGLoaderView/GGLoaderView';
import Footer from '../../components/CommonComponents/Footer/Footer';
import logAnalyticsEvent from '../../services/AnalyticsManager/AnalyticsManager';
import { GGAnalyticsEvents } from '../../services/AnalyticsManager/GGAnalyticsEvents';

const GigListPage = () => {

  const [pageNum, setPageNum] = useState(1);
  const [pageSize] = useState(12);
  const [totalGigs, setTotalGigs] = useState(0);
  const [gigList, setGigList] = useState<Gig[]>([]);
  const [currGigList, setCurrGigList] = useState<Gig[]>([]);
  const {subcategoryId} = useParams();
  const [subcategory, setSubcategory] = useState<Subcategory>();
  const [loadingActive, setLoadingActive] = useState(false);

  // Snackbar based status handling 
  const snackBarRef = useRef<{showSnackbar(): any}>(null)
  const [snackBarParams, setSnackBarParams] = useState({
    message: "",
    state: SnackTypes.error
  });

  const showSnackbar = (message: string, state: SnackTypes ) => {
    setSnackBarParams({message: message, state: state})
    snackBarRef.current?.showSnackbar()
  }

  const updateGigsForPageNumber = (pageNumber: number) => {
    setLoadingActive(true)
    GigAPIHandler.shared.getGigsBySubcategory(subcategoryId as string, pageNumber, pageSize).then( (gigResponse) => {
      setGigList(gigResponse.gigs)
      setTotalGigs(gigResponse.totalGigs)
      setCurrGigList(gigList)
      setLoadingActive(false)
    }).catch((err) => {
      setLoadingActive(false)
      showSnackbar(err, SnackTypes.error)
    })
  }
  
  useEffect(() => {

    document.title = "GenieGig | Gig List";
    window.scrollTo(0,0)
    logAnalyticsEvent(GGAnalyticsEvents.GIG_LIST_PAGE_LOADED);

    SubcategoryAPIHandler.shared.getSubcategoryById(subcategoryId as string).then( subCategory => {
      setSubcategory(subCategory)
    }).catch((err) => {
      showSnackbar(err, SnackTypes.error)
    })

    updateGigsForPageNumber(pageNum)

// eslint-disable-next-line
  }, [subcategoryId])

  useEffect(() => {
    setCurrGigList(gigList)
  }, [gigList])

  useEffect(() => {
    updateGigsForPageNumber(pageNum)
    
    // eslint-disable-next-line
  }, [pageNum])

  return (
    <div>
      {loadingActive && <GGLoaderView/>}
      <Navbar useScrollVersion={true}/>
      <GiglistBanner subcategory={subcategory}/>
      <GigListSorter data={gigList} setData={setGigList} />
      <GigListContainer gigList={currGigList} />
      <PaginationComp 
        data={gigList}
        pageNum={pageNum}
        setPageNum={setPageNum}
        setCurData={setCurrGigList}
        dataLength={totalGigs}
        itemsPerPage={pageSize}
      />
      <Footer />
      <SnackBar ref={snackBarRef} severity={ snackBarParams.state } alertDuration={5000} message={snackBarParams.message} />

    </div>
  )
}

export default GigListPage